export default "__VITE_ASSET__CKViXY2x__"